<div class="cleanup-modal">
  <h2 class="cleanup-title">Map Cleanup</h2>
  <p class="cleanup-info">{{ upgradePlan?.name | uppercase }} subscription allows for <strong>{{ maxMaps }}</strong> maps.</p>

  @if (mapsToDelete.length > 0) {
    <div class="cleanup-table-wrap">
      <table class="cleanup-table">
        <thead>
          <tr>
            <th>Map</th>
            <th>Active Games</th>
            <th>Active Characters</th>
            <th>Placed Content</th>
          </tr>
        </thead>
        <tbody>
          @for (m of mapsToDelete; track m) {
            <tr>
              <td class="cleanup-danger">{{ m.map_name }}</td>
              <td>{{ m.active_games }}</td>
              <td>{{ m.active_characters }}</td>
              <td class="cleanup-danger">{{ getPlacedContent(m) }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <p class="cleanup-summary cleanup-summary--danger">
      <span class="cleanup-summary-count">{{ mapNamesToDelete }}</span> map(s) will be deleted
    </p>
  } @else {
    <p class="cleanup-summary cleanup-summary--success">No maps require deletion</p>
  }

  <div class="cleanup-actions">
    @if (!downgradeResponse?.cleanup_required) {
      <button type="button" class="btn btn-outline" (click)="close()">Cancel</button>
    }
    <button type="button" class="btn btn-theme" (click)="next()">Proceed</button>
    <button type="button" class="btn btn-theme" (click)="subscribe()">Subscribe</button>
  </div>
</div>
